import React from 'react';
import { PricingMoleculeSolo } from './PricingMoleculeSolo';
import { PricingMoleculeDefault } from './PricingMoleculeDefault';
import { PricingMoleculeCommon } from './PricingMoleculeCommon';
import { FEELIX_THEMES } from '../../../constants';
import { PricingMoleculeProps } from './types';

export const PricingMolecule =
  ({
    theme,
    ...props
  }: PricingMoleculeProps & { theme: string}) => {
    if (theme === FEELIX_THEMES.SOLO) {
      return <PricingMoleculeSolo {...props} />;
    }

    if (theme === FEELIX_THEMES.COMMON) {
      return <PricingMoleculeCommon {...props} />;
    }

    return <PricingMoleculeDefault {...props} />;
  };
